import { render, staticRenderFns } from "./DecorationServiceDialog.vue?vue&type=template&id=10544348"
import script from "./DecorationServiceDialog.vue?vue&type=script&lang=js"
export * from "./DecorationServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports